import React, { useEffect, useState } from 'react';
import { ProductModal } from '../views/orders/Modal';
import { useNavigate } from 'react-router';
import { OrderCheckingModal } from './Modal';


export function Header({ page })
{
  const navigate = useNavigate();
  const [cartOpen, setCartOpen] = useState(false);

  const signout = () =>{
     localStorage.clear();
     navigate('/');
  } 

    return(

      <div className='col-12 bg-dark pb-3 topIndex'>

        <nav className= {`navbar navbar-expand-xl px-3 bg-dark py-0`} data-bs-theme="dark">
          <div className="container-fluid ">
            {/* Logo */}
            <a className="navbar-brand d-flex align-items-center py-3 px-3 bg-green rounded-bottom" href="/">
              <span className="text-light"> <i className="bi bi-grid me-1"></i> </span>
              <span className="text-light"> Ortega </span>
            </a>
            {/* Burger menu pour mobile */}
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
             {/* Navigation menu */}
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item mx-2">
                  <a className={`nav-link ${(page===1) && 'text-light'}`} href="/"> { (page===1) && ( <i className="bi bi-arrow-right-circle"></i> ) }  Accueil </a>
                </li>
                <li className="nav-item mx-2">
                  <a className={`nav-link ${(page===2) && 'text-light'}`} href="/produits"> { (page===2) && ( <i className="bi bi-arrow-right-circle"></i> ) } Produits </a>
                </li>
                <li className="nav-item mx-2">
                  <a className={`nav-link ${(page===3) && 'text-light'}`} href="/services"> { (page===3) && ( <i className="bi bi-arrow-right-circle"></i> ) } Services </a>
                </li>
                <li className="nav-item mx-2">
                  <a className={`nav-link ${(page===4) && 'text-light'}`} href="/apropos"> { (page===4) && ( <i className="bi bi-arrow-right-circle"></i> ) } Apropos </a>
                </li>
                <li className="nav-item mx-2">
                  <a className={`nav-link ${(page===5) && 'text-light'}`} href="/contact"> { (page===5) && ( <i className="bi bi-arrow-right-circle"></i> ) } Contact </a>
                </li>
                {
                  localStorage.getItem('token') && (
                    <li className="nav-item mx-2">
                      <a className={`nav-link ${(page===6) && 'text-light'}`} href="/commandes-en-cours"> { (page===6) && ( <i className="bi bi-arrow-right-circle"></i> ) } Mes-commandes </a>
                    </li>
                  )
                }
              </ul>
              {/* Actions à droite */}
              <div className="d-flex align-items-center gap-3">
                {
                  localStorage.getItem('token') ? 
                  ( <button className="btn btn-sm btn-outline-light" onClick={ signout } type="button"> Se déconnecter </button> ) :
                  ( <a href="/connexion" className="btn btn-sm btn-outline-light"  > Se connecter </a > ) 
                }    
                 <button className="btn btn-sm btn-outline-light" type="button" onClick={() => setCartOpen(true)} > 
                  <i className="bi bi-cart"></i> 
                 </button> 
                 <a href='/produits' className="btn btn-sm btn-outline-light" > 
                  <i className="bi bi-search"></i> 
                 </a> 

                  {/* Cart Sidebar */}
                 <CartSidebar open={cartOpen} onClose={() => setCartOpen(false)} />

              </div>
            </div>
          </div>
        </nav>

      </div>

    )
}





export function TopBar() 
{
  return (

    <div className="col-12">
      <div className={`row bg-green d-flex justify-content-between align-items-center`}> 
        {/* ****************************************************************** */}
        <div className="col-md-5 d-flex align-items-center"> 
          <div className="d-flex align-items-center justify-content-center me-4 py-3">
            <i className="bi bi-envelope text-white me-1 mt-1 small hide"></i>
            <a href="mailto:contact@ortega-hub.com" className="text-light hide" style={{ textDecoration: 'none' }}> contact@ortega-hub.com </a>
          </div>
        </div>
        {/* ****************************************************************** */}
        <div className="col-md-6 d-flex align-items-center justify-content-end"> 
          <div className="hide-lg gap-2 p-3 me-4 bg-dark"> 
            <a className="me-2 nav-link border border-light px-1 rounded-2" target="blank" href="https://x.com/OrtegaContact"> <i className="small bi bi-twitter-x text-white"></i> </a>
            <a className="me-2 nav-link border border-light px-1 rounded-2" target="blank" href="https://www.facebook.com/61588918603527"> <i className="small bi bi-facebook text-white"></i> </a>
            <a className="me-2 nav-link border border-light px-1 rounded-2" target="blank" href="https://www.linkedin.com/company/ortega-hub"> <i className="small bi bi-linkedin text-white"></i> </a>
            <a className="me-2 nav-link border border-light px-1 rounded-2" target="blank" href="https://www.instagram.com/ortegacontact"> <i className="small bi bi-instagram text-white"></i> </a>
          </div>
        </div>
        {/* ****************************************************************** */}
      </div> 
    </div>
  );
}


function CartSidebar({ open, onClose }) 
{
  const navigate = useNavigate();
  const [showDetail, setShowDetail] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cart, setCart] = useState([]);

  
  const handleEdit = ( product ) => {
    setSelectedProduct( product );
    setShowDetail(true);
  };

  // Charger le panier depuis localStorage
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
  }, [open]); // recharge à chaque ouverture

  // Faire une commande
  const setOrder = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/nouveau-commande");
    } else {
      setShowForgotModal(true);
    }
  };

  // Supprimer un produit
  const handleRemove = (productId) => {
    const updatedCart = cart.filter(
      (item) => item.product.id !== productId
    );
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  // Calcul du total général
  const totalAmount = cart.reduce((total, item) => {
    return total + item.product.price * item.count;
  }, 0);

  if (!open) return null;

  return (
    <>
      <div className="cart-backdrop" onClick={onClose}></div>

      <aside className="cart-offcanvas">
        <header className="cart-header bg-green text-light d-flex justify-content-between align-items-center px-4 py-3">
          <h5>
            <i className="bi bi-cart3 me-2"></i> Mon panier
          </h5>
          <button className="cart-close" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </header>

        {/* CART PRODUCTS */}
        <div className="d-flex flex-column text-secondary p-4 mb-3">

          {cart.length === 0 && (
            <div className="d-flex flex-column gap-2 justify-content-center align-items-center p-3 border border-secondary">
              <i className="bi bi-folder-x lead fs-1"></i>
              <span className="lead text-dark"> Panier vide </span>
            </div>
          )}

          {cart.length > 0 && (
            <div className="d-flex flex-column px-3" style={{ maxHeight: "65vh", overflowY: "auto" }} >
            { cart.map((item) => (
                <div key={item.product.id} className="border border-secondary d-flex flex-column flex-lg-row gap-3 mb-3 ps-3">
                  <div className="product-image p-3 bg-light">
                    <img src={item.product.images[0].url} alt={item.product.name} style={{ width: "100px" }} />
                  </div>

                  <div className="product-info border-start border-secondary p-3 w-100">
                    <div className="d-flex justify-content-between w-100 mb-2">
                      <span className="text-secondary fw-bold">
                        {item.product.name}
                      </span>
                      <div className='d-flex gap-3'> 
                        <button className='btn btn-sm btn-outline-green' onClick={() => handleEdit(item.product )}> 
                          <i className="bi bi-box-arrow-up-right"></i> 
                        </button> 
                        <button className='btn btn-sm btn-outline-danger' onClick={() => handleRemove(item.product.id) } > 
                          <i className="bi bi-x-circle"></i> 
                        </button> 
                      </div>
                    </div>

                    <div className="d-flex justify-content-between w-100">
                      <span>Prix unitaire :</span>
                      <span>
                        {item.product.price.toLocaleString() + " " + item.product.currency }
                      </span>
                    </div>

                    <div className="d-flex justify-content-between w-100">
                      <span>Quantité :</span>
                      <span>{item.count}</span>
                    </div>

                    <div className="d-flex justify-content-between w-100 mt-2">
                      <span className="text-dark">Prix total</span>
                      <span className="h6 text-dark">
                        { (item.product.price * item.count).toLocaleString() + " " + item.product.currency } 
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <footer className="cart-footer">
          <div className="total px-4">
            <span> Montant total :</span>
            <strong>{totalAmount.toLocaleString()} FCFA</strong>
          </div>

          <button className="btn btn-green w-100 py-2" onClick={setOrder} disabled={cart.length === 0} >
            Passer à la commande
            <i className="bi bi-chevron-right ms-2"></i>
          </button>
        </footer>

      </aside>

      {/* Modal de previsualisation */}
      {
        selectedProduct && (<ProductModal show={showDetail} product={selectedProduct} onHide={() => setShowDetail(false)} />)
      }
        
      {/* Checker Modal */}
      <OrderCheckingModal show={showForgotModal} onHide={() => setShowForgotModal(false)}/>

    </>
  );
}
